import { render, staticRenderFns } from "./TabZero.vue?vue&type=template&id=4075d404&scoped=true&"
import script from "./TabZero.vue?vue&type=script&lang=js&"
export * from "./TabZero.vue?vue&type=script&lang=js&"
import style0 from "./TabZero.vue?vue&type=style&index=0&id=4075d404&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4075d404",
  null
  
)

export default component.exports